<template>
  <v-container id="result-report" fluid tag="section">
    <filter-form 
      :filter-form="filterForm" 
      :ministries="ministries"
    />
    <report-table v-show="!loading" :reports="reports" />
    <RevenueReportChart v-if="!loading && departmentMinutes.length" :dataChart="dataChart" />
    <RatioReportChart v-if="!loading && departmentMinutes.length" :dataChart="dataChart" />
    <v-card v-if="!loading && departmentMinutes.length == 0" class="pb-2">
      <common-no-result />
    </v-card>
  </v-container>
</template>
<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment';
import FilterForm from './components/FilterForm';
import ReportTable from './components/ReportTable';
import RevenueReportChart from './components/RevenueReportChart'
import RatioReportChart from './components/RatioReportChart';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ReportRepository = RepositoryFactory.get('report');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
export default {
  components: { FilterForm, ReportTable, RevenueReportChart, RatioReportChart },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        },
        shift: [],
        ministryIds: []
      },
      reports: {},
      departmentMinutes: [],
      dataChart: {
        labels: [],
        successTurnOver: [],
        initTurnOver: [],
        departmentInitLatchRatio: []
      },
      loading: true,
      watchModule: '',
      ministries: []
    };
  },
  created() {
    this.getListMinistry()
    this.getAPIReport();
    Bus.$on('report-list-filter', filterForm => {
      this.filterForm = filterForm;
      this.getAPIReport();
    });

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          dateRange: {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          shift: [],
          ministryIds: []
        }
      
        Bus.$emit('report-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('report-list-filter');
    this.watchModule()
  },
  methods: {
    async getAPIReport() {
      const loader = this.$loading.show();
      this.loading = true;
      await Promise.all([
        this.getDepartmentSummary(),
        this.getDepartmentChart()
      ]);
      this.loading = false;
      loader.hide();
    },
    async getDepartmentSummary() {
      const params = {
        startDate: this.formatDate(this.filterForm.dateRange.startDate),
        endDate: this.formatDate(this.filterForm.dateRange.endDate),
        shift: this.filterForm.shift,
        ministryIds: this.filterForm.ministryIds,
        departmentType: 'retail',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };

      const response = await ReportRepository.departmentSummary(params);
      if (response.success) {
        this.reports = _.get(response, 'data', {});
      } else {
        this.departmentMinutes = []
      }
    },
    async getDepartmentChart() {
      const params = {
        startDate: this.formatDate(this.filterForm.dateRange.startDate),
        endDate: this.formatDate(this.filterForm.dateRange.endDate),
        shift: this.filterForm.shift,
        ministryIds: this.filterForm.ministryIds,
        departmentType: 'retail',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };

      const response = await ReportRepository.departmentChart(params);
      if (response.success) {
        this.departmentMinutes = _.get(response, 'data', []);
        this.getMultiLineData();
      }
    },
    getMultiLineData() {
      const labels = [];
      const successTurnOver = [];
      const initTurnOver = [];
      const departmentInitLatchRatio = [];
      this.departmentMinutes.forEach(data => {
        const label = Object.keys(data)[0];
        labels.push(label);
        successTurnOver.push(Number(_.get(data, `${label}.successTurnOver`, 0) / 1000000).toFixed(2));
        initTurnOver.push(Number(_.get(data, `${label}.initTurnOver`, 0) / 1000000).toFixed(2));
        departmentInitLatchRatio.push(_.get(data, `${label}.departmentInitLatchRatio`, 0).toFixed(2));
      });
      this.dataChart = {
        labels,
        successTurnOver,
        initTurnOver,
        departmentInitLatchRatio
      };
    },
    async getListMinistry() {
      const res = await OrganizationMachineRepository.listMinistryOnly()

      if (res.success) {
        this.ministries = _.get(res, 'data', [])
      } else {
        this.ministries = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  }
};
</script>
